import { render } from "./addButton.vue?vue&type=template&id=5bb73a6d&scoped=true&ts=true"
import script from "./addButton.vue?vue&type=script&lang=ts"
export * from "./addButton.vue?vue&type=script&lang=ts"

import "./addButton.vue?vue&type=style&index=0&id=5bb73a6d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb73a6d"]])

export default __exports__